export type Permission = string;
export type PermissionsMap = {
  [key: string]: boolean;
};

const convertArrayToObject = (array: string[]) => {
  const initialValue = {};

  return array.reduce(
    (obj, item) => ({
      ...obj,
      [item]: true,
    }),
    initialValue,
  );
};

export default convertArrayToObject;
